import ReactDOMServer from 'react-dom/server';

const convertMarkdownToHtml = (markdown: string): string => {
  if (!markdown) return '';

  markdown = markdown?.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  markdown = markdown?.replace(/^\s*-\s+(.*)/gm, '<ul><li>$1</li></ul>');
  markdown = markdown?.replace(/<\/ul>\s*<ul>/g, '');
  markdown = markdown?.replace(
    /\[(.*?)\]\((.*?)\)/g,
    '<a href="$2" style="color: #00A1E0;">$1</a>'
  );
  markdown = markdown?.replace(/\n/g, '<br />');

  return markdown;
}

const replaceHtmlTextWithIcon = (
  text: string,
  targetText: string,
  IconComponent: React.ComponentType<{ className?: string }>,
  className?: string
): string => {
  const iconHtml = ReactDOMServer.renderToStaticMarkup(
    <IconComponent className={className || 'inline align-top'} />
  );
  const regex = new RegExp(targetText, 'g');
  return text?.replace(regex, iconHtml);
};

// TODO test
const replaceTextWithIcon = (
  text: string,
  IconComponent: React.ComponentType<{ className?: string }>,
  className?: string
): React.ReactNode => {
  return (
    <>
      <IconComponent className={className} />
      <span className="ml-1">{text}</span>
    </>
  );
};


const markdownHelpers = {
  convertMarkdownToHtml,
  replaceHtmlTextWithIcon,
  replaceTextWithIcon,
};

export default markdownHelpers;
